import { render, staticRenderFns } from "./app-heading.vue?vue&type=template&id=030ac8d4&scoped=true"
import script from "./app-heading.vue?vue&type=script&lang=js"
export * from "./app-heading.vue?vue&type=script&lang=js"
import style0 from "./app-heading.vue?vue&type=style&index=0&id=030ac8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030ac8d4",
  null
  
)

export default component.exports